import { apiClient } from '@/api/client';
import { CreateNewBookingDto } from '../../DTOS';
import { ENDPOINTS } from '@/api/endpoints';

export const createNewBooking = async (booking: CreateNewBookingDto) => {
  return await apiClient.post(ENDPOINTS.BOOKINGS, booking);
};
